import { create } from 'zustand';
import { CasemasterAssessmentStates, InterviewerStates, QuestionStates, QuestionsTypes } from './constant';

const useCaseMasterStore = create((set, get) => ({
  // Assessment State
  assessmentState: CasemasterAssessmentStates.FULL_SCREEN_PERMISSION,
  setAssessmentState: (state) => set({ assessmentState: state }),

  // Question State
  questionState: QuestionStates.WAITING,
  setQuestionState: (state) => set({ questionState: state }),

  // Interviewer State
  interviewerState: InterviewerStates.LISTENING,
  setInterviewerState: (state) => set({ interviewerState: state }),

  // Question Type
  questionType: QuestionsTypes.CASE_INTRO,
  setQuestionType: (type) => set({ questionType: type }),

  // CaseMaster Problem Data
  casemasterProblem: null,
  setCasemasterProblem: (casemasterProblem) => set({ casemasterProblem }),

  // Attempt Data
  attempt: null,
  setAttempt: (attempt) => set({ attempt }),

  // Response Tracking
  hasGivenResponse: false,
  setHasGivenResponse: (value) => set({ hasGivenResponse: value }),

  // Timer
  timeLeft: 0,
  setTimeLeft: (time) => set({ timeLeft: time }),
  timeOut: false,
  setTimeOut: (timeOut) => set({ timeOut }),
  totalDuration: 1800, // 30 minutes in seconds
  setTotalDuration: (duration) => set({ totalDuration: duration }),

  // Analysis Data
  analysis: {
    [QuestionsTypes.CASE_INTRO]: {},
    [QuestionsTypes.CASE_ANALYSIS]: {},
    [QuestionsTypes.FOLLOW_UP_1]: {},
    [QuestionsTypes.FOLLOW_UP_2]: {}
  },
  updateAnalysis: (data) => {
    const { questionType } = get();
    set((state) => ({
      analysis: {
        ...state.analysis,
        [questionType]: { ...state.analysis[questionType], ...data }
      }
    }));
  },

  // Section Time Data
  sectionTimeData: {
    showTimer: true,
    warningTime: 60,
    [QuestionsTypes.CASE_INTRO]: { duration: 180 }, // 3 minutes
    [QuestionsTypes.CASE_ANALYSIS]: { duration: 300 }, // 5 minutes
    [QuestionsTypes.FOLLOW_UP_1]: { duration: 120 }, // 2 minutes
    [QuestionsTypes.FOLLOW_UP_2]: { duration: 120 }  // 2 minutes
  },

  // Actions
  startAssessment: () => {
    const currentState = get();
    console.log('Starting assessment with totalDuration:', currentState.totalDuration);
    set({
      assessmentState: CasemasterAssessmentStates.RUNNING,
      questionState: QuestionStates.AI_SPEAKING
    });
  },

  endTutorial: () => {
    set({ assessmentState: CasemasterAssessmentStates.FETCHING_CASEMASTER_PROBLEM });
  },

  // Reset Store
  reset: () => {
    set({
      assessmentState: CasemasterAssessmentStates.FULL_SCREEN_PERMISSION,
      questionState: QuestionStates.WAITING,
      interviewerState: InterviewerStates.LISTENING,
      questionType: QuestionsTypes.CASE_INTRO,
      casemasterProblem: null,
      attempt: null,
      hasGivenResponse: false,
      timeLeft: 0,
      timeOut: false,
      totalDuration: 1800,
      analysis: {
        [QuestionsTypes.CASE_INTRO]: {},
        [QuestionsTypes.CASE_ANALYSIS]: {},
        [QuestionsTypes.FOLLOW_UP_1]: {},
        [QuestionsTypes.FOLLOW_UP_2]: {}
      }
    });
  }
}));

export default useCaseMasterStore;

